import { useCallback } from 'react'
import { Button } from '@highlight/ui'
import { GlobalEvents } from '@highlight/ipc'
import { AmplitudeRenderer } from '@renderer/utils/amplitude.renderer.ts'
import { Toast, useToast } from '../index'

interface InactivityToastProps {
  toastId: string
  minutes: number
}

export const InactivityToast = ({ toastId, minutes }: InactivityToastProps) => {
  const toast = useToast()

  const handleConfirm = useCallback(() => {
    GlobalEvents.emit('audio-note:keep-recording')
    AmplitudeRenderer.trackEvent('Inactivity Prompt', {
      action: 'confirmed still recording',
    })
    toast.dismiss(toastId)
  }, [toast, toastId])

  return (
    <Toast toastId={toastId}>
      <Toast.Content>
        <Toast.Description>{`No speech detected for ${minutes} minutes`}</Toast.Description>
        <Toast.Actions>
          <Button size="sm" variant="primary" onClick={handleConfirm}>
            Yes, I&apos;m still here
          </Button>
        </Toast.Actions>
      </Toast.Content>
    </Toast>
  )
}
